import { FC } from 'react'

import { Card, Cluster, FeedItem, Typography } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedActorAvatar } from './ActivityFeedActorAvatar'
import { ActivityFeedItemProps } from './types'

export const ActivityFeedItemMessage: FC<ActivityFeedItemProps> = ({ item, status }) => {
  const { translate, translateDate } = useLocalisation()
  return (
    <FeedItem
      type="message"
      name={item.activity.actor.fullName || 'Service'}
      action={
        <Cluster gap={8} y="center">
          <Typography variant="body">{translate('feed.list.message.action')} </Typography>
        </Cluster>
      }
      date={translateDate('feed_date', item.activity.createdAt)}
      suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
      status={status}
    >
      <a id={`feed-activity-${item.id}`} />
      <Card>
        <Cluster gap={8}>
          <ActivityFeedActorAvatar actor={item.activity.actor} />
          <Typography preformatted variant="body">
            {item.activity.customField.feedV1Activity?.content ?? '–'}
          </Typography>
        </Cluster>
      </Card>
    </FeedItem>
  )
}
